import { BrowserRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './styles/index.scss';

import { AuthProvider } from './contexts/AuthContext';
import { STRIPE_PUBLIC_KEY } from './config';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

root.render(
  <BrowserRouter>
    <Elements stripe={stripePromise}>
      <Toaster position="top-right" />
      <AuthProvider>
        <App />
      </AuthProvider>
    </Elements>
  </BrowserRouter>,
);

/* <React.StrictMode> */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
